import config from '@/config';
import store from '@/store';
import router from '@/router';
import axios from 'axios';
import { handleException } from '@/scripts/http/exceptions';

/**
 * Create the request url
 *
 * @param url The url
 * @param urlQuery The query string object
 * @param relations The relations to include
 *
 * @returns string
 */
export const makeUrl = (url, urlQuery = null, relations = null) => {
    // If the url is an array then create url string
    if (Array.isArray(url)) {
        url = '/' + url.join('/')
    }

    url = config.API_API_URL + url

    const query = []
    if (urlQuery) {
        for (const key in urlQuery) {
            const value = urlQuery[key]
            query.push(`${key}=${value}`)
        }
    }

    if (relations) {
        query.push('with=' + relations)
    }

    if (query.length >= 1) {
        return url + '?' + query.join('&')
    }

    return url
}

/**
 * Make a request to the api
 *
 * @param method
 * @param url
 * @param params
 * @param relations
 *
 * @returns Promise
 */
const makeRequest = (method, url, params = null, relations = null) => {
    const options = {
        method: method,
        headers: {
            'accept': 'application/json',
            'content-type': 'application/json'
        },
    }

    // Add the access token if it exists
    if (store.getters.accessToken.token) {
        options.headers.Authorization = `Bearer ${store.getters.accessToken.token}`
    }

    // For a get request add params to url query otherwise add to request body
    if (method.toLowerCase() === 'get') {
        options.url = makeUrl(url, params, relations)
    } else {
        options.url = makeUrl(url, null, relations)
        options.data = params
    }

    // Make the request
    return axios(options)
}

/**
 * Make a request to the api
 *
 * @param method The request method
 * @param url The request url
 * @param params The data for the request (if any)
 * @param relations Any "with" relations to pass to url
 *
 * @returns Promise
 */
export const request = (method, url, params = null, relations = null) => {
    return new Promise((resolve, reject) => {
        // Build the options object
        makeRequest(method, url, params, relations)
            .then(async ({ data }) => {
                resolve(data)
            }).catch(async (error) => {
                const results = handleException(error);
                if (results) {
                    if (results.reject) {
                        reject(results.reject);
                    }
                } else {
                    // Something happened in setting up the request that triggered an Error
                    reject(error.message)
                }
            })
    })
}
